<script setup lang="ts">
import type { IAiChatAbout } from './types'
import { Button } from '~/components/ui/button'
import { AirunLogo } from '~/components/ui/airun'

const props = defineProps<{ item: IAiChatAbout }>()
const { t } = useI18n()
const { trackEvent } = useAnalytics()

const href = computed(() => {
  const url = new URL(props.item.url)
  url.searchParams.set('utm_source', 'banks.kg')
  url.searchParams.set('utm_medium', 'referral')
  url.searchParams.set('utm_campaign', 'ai_chat')
  return url.toString()
})

const trackClick = () => {
  trackEvent('partner_link_click', { partner: 'airun', link_location: 'ai_chat' })
}
</script>

<template>
  <div class="AiCard">
    <div class="flex items-center gap-3">
      <AirunLogo class="h-10 w-10 shrink-0" />
      <div class="min-w-0 flex-1">
        <div class="text-sm font-semibold text-gray-900">{{ item.name }}</div>
        <div class="text-xs text-gray-500">{{ t('widget_ai_chat.airun.description') }}</div>
      </div>
    </div>
    <Button as-child variant="outline-blue" size="sm" class="mt-3 w-full">
      <a :href="href" target="_blank" rel="noopener noreferrer" @click="trackClick">
        {{ t('widget_ai_chat.airun.button') }}
      </a>
    </Button>
  </div>
</template>
